// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Container_container__VRrje {
  margin: 0 auto;
  padding: 0;
  width: 100%;
  max-width: 1920px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Container/Container.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AACD","sourcesContent":[".container {\n\tmargin: 0 auto;\n\tpadding: 0;\n\twidth: 100%;\n\tmax-width: 1920px;\n\toverflow: hidden;\n\n\t// @media (max-width: 768px) {\n\t// \twidth: 734px;\n\t// \tpadding: 0;\n\t// \tmargin: 0 auto;\n\t// }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Container_container__VRrje`
};
export default ___CSS_LOADER_EXPORT___;
